<span fxFlex="100">
  <Label>{{label}}<span *ngIf="optional === true" class="op-text">(optional)</span></Label>
  <ng-content></ng-content>
</span>
